/**
 * Resolves once the page has stopped scrolling.
 *
 * Used to hold an entrance animation back until a smooth `scrollIntoView` has
 * landed: running both at once makes the browser paint new layers while it is
 * still scrolling, which is what made the jump to the vehicle list stutter.
 *
 * "Stopped" means no scroll event for `quietMs`. Scroll events are used rather
 * than the `scrollend` event because `scrollend` never fires when the page was
 * already in place, and older Safari doesn't send it at all.
 *
 * @param {number} quietMs    how long the page must be still
 * @param {number} maxWaitMs  give up and resolve anyway after this long
 * @returns {Promise<void>}   never rejects
 */
const waitForScrollToSettle = (quietMs = 120, maxWaitMs = 1500) =>
  new Promise((resolve) => {
    let quietTimer = null;
    let maxWaitTimer = null;

    const finish = () => {
      window.removeEventListener("scroll", restartQuietTimer);
      clearTimeout(quietTimer);
      clearTimeout(maxWaitTimer);
      resolve();
    };

    function restartQuietTimer() {
      clearTimeout(quietTimer);
      quietTimer = setTimeout(finish, quietMs);
    }

    window.addEventListener("scroll", restartQuietTimer, { passive: true });
    // Also covers "nothing scrolled at all": the timer simply runs out.
    restartQuietTimer();
    maxWaitTimer = setTimeout(finish, maxWaitMs);
  });

export default waitForScrollToSettle;
